import { create } from 'zustand';

/** A dismissible surface (overlay, dialog, popover, or an internal step) that the
 *  native Telegram BackButton should target before it pops the route stack. */
export interface BackHandler {
  id: string;
  fn: () => void;
}

interface BackState {
  handlers: BackHandler[];
  register: (id: string, fn: () => void) => void;
  unregister: (id: string) => void;
}

/** LIFO registry of back handlers. The App shell wires the native Telegram
 *  BackButton to the topmost handler (overlay/step) and falls back to nav.pop().
 *  See `useBackHandler` for the component-facing API. */
export const useBack = create<BackState>((set) => ({
  handlers: [],
  register: (id, fn) =>
    set((s) => {
      const rest = s.handlers.filter((h) => h.id !== id);
      return { handlers: [...rest, { id, fn }] };
    }),
  unregister: (id) =>
    set((s) => ({ handlers: s.handlers.filter((h) => h.id !== id) })),
}));
